import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'

import './index.css'
import './helpers/style/custom.scss'

import * as serviceWorker from './serviceWorker'
import App from './App'
import { store } from './helpers/store'

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
